<template>
  <div class="loading-container">
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="46" />
    </svg>
  </div>
</template>

<script>
import { TweenMax } from "greensock";
import eventBus from "../eventBus";

export default {
  name: "loading-container",
  mounted() {
    eventBus.$on("intro-out", this.animateIn);
    eventBus.$on("hide-loader", this.animateOut);
  },
  methods: {
    animateIn() {
      TweenMax.to(".loading-container", 1, {
        opacity: 1,
        ease: Expo.easeInOut
      });
    },
    animateOut() {
      TweenMax.to(".loading-container", 1, {
        opacity: 0,
        ease: Expo.easeInOut
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-container {
  position: absolute;
  bottom: 50px;
  left: calc(50% - 25px);

  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;

  opacity: 0;

  z-index: 10;

  svg {
    width: 100%;
    max-width: 10rem;
    animation: rotate 3.6s linear infinite;
  }

  circle {
    fill: none;
    stroke: black;
    stroke-width: 6px;
    stroke-dasharray: 300;
    animation: outline 2s cubic-bezier(0.77, 0, 0.18, 1) infinite;
  }

  @keyframes outline {
    0% {
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dashoffset: 300;
    }
    100% {
      stroke-dashoffset: 600;
    }
  }

  @keyframes rotate {
    from {
      transform: rotate(0turn);
    }
    to {
      transform: rotate(-1turn);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/loading.vue